export class ForbiddenWebError extends Error {
    errorCode: string;
    constructor(message: string, errorCode: string) {
        super(message);
        this.name = "ForbiddenWebError";
        this.errorCode = errorCode;

        // Known issue with typescript, fixes instanceof not working for custom errors
        Object.setPrototypeOf(this, ForbiddenWebError.prototype);
    }
}
